import styled from 'styled-components';
import { Colors } from '~/config/Colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .content-gantt {
    background: ${Colors.Color13};
    width: 100%;
    height: 30em;
    border-radius: 1em;
    padding: 1.1em;

    .header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.15em 0.8em 0.15em 0.3em;
        width: fit-content;

        img {
          width: 1.4em;
        }

        .title {
          font-size: 0.8125em;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5em;
        }
      }
    }

    .body {
      border-radius: 1em;
      height: calc(100% - 3.2em);
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;
      overflow: auto;

      .body-left {
        width: 15em;
        position: sticky;
        left: 0px;
        z-index: 2;
          
        .body-header {
          padding: 0 1.3em;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .body-content {
          width: 100%;
          height: 40em;
        }
      }

      .body-right {
        border-radius: 0 1em 0 0;
        width: calc(100% - 15em);
        z-index: 1;

        .body-header {
          width: max-content;
        }

        .body-content {
          width: max-content;
          height: 40em;
        }
      }

      .body-header {
        width: 100%;
        background: ${Colors.Color2};
        height: 4em;
        position: sticky;
        top: 0px;

        .semanas {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .info-cab {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          background: ${Colors.Color27};
          border-radius: 0.4em;
          padding: 0.15em 0.8em 0.15em 0.3em;
          width: fit-content;

          p {
            font-size: 0.8125em;
            font-weight: 700;
            color: ${Colors?.Color4};
            margin-left: 0.5em;
          }
        }
      }

    }
  }

  .content-os {
    margin-right: 2em;

  }

  .filtro {
    display: flex;
    flex-direction: row;
    margin-bottom: 1.5em;

    .item {
      width: 9em;
      margin-left: 1em;
      
      select {
        width: 100%;
      }
    }
  }
`;

export const BodyColuna = styled.div`
  height: ${(props) => props?.height};
`;

export const ThisCardItem = styled.div`
  .item {
    cursor: pointer;
    padding: 0em 0.7em 0em 0.7em;
    display: flex;
    flex-direction: row;
    background: ${Colors.Color26};
    width: 100%;
    align-items: center;
    border-right: 3px solid #242424;

    .item-colunas {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 3em;

      .row-coluna {
        margin-left: 0.6em;
        
        p {
          font-size: 0.7em;
          font-weight: 700;
          color: ${Colors.Color4};
        }
      }

      .row-data {
        display: flex;
        flex-direction: row;
        height: 1em;

        .data-text {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 0.6em;

          img {
            width: 0.7em;
          }

          p {
            font-size: 0.55em;
            color: ${Colors.Color14};
            margin-left: 0.5em;
          }
        }
      }
    }

    .limite {
      height: 3em;
      width: 0.15em;
      background: #6796cf;
      margin-left: -0.7em;
      margin-right: 0.7em;
    }
    
    .open {
      height: 0.8em;
      width: 0.8em;
      background:  ${Colors.Color2};
      margin-right: 0.6em;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${Colors.Color4};
    }

    .titulo {
      font-size: 0.7em;
      font-weight: 600;
      color: ${Colors.Color4};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100%);
    }

  }

  .light {
    background: ${Colors.Color8} !important;
  }

  .subItem {
    padding: 0em 0.7em 0em 1em !important;
    background: #282828 !important;
    border-right: 3px solid #242424;

    .limite {
      background: #355D8E !important;
    }
  }

  .subSubItem {
    padding: 0em 0.7em 0em 1.3em !important;
    background: #2f2f2f !important;
    border-right: 3px solid #242424;

    .limite {
      background: #204471 !important;
    }
  }

`;

export const ThisGanntCol = styled.div`
  .item {
    display: flex;
    flex-direction: row;
    background: ${Colors.Color26};
    height: 2em;
    align-items: center;
    border-right: 3px solid #242424;

    .col-dias {
      border-right: 3px solid #242424;
      background: #2a2a2a;
    }

    .col {
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 2em;
      align-items: center;
      justify-content: center;

      .card-dia{
        background: #2a2a2a;
        height: 1.6em;
        width: 2em;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;

        .dia {
          font-size: 0.65em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }

      .barra {
        background-color: #242424;
        height: 1em;
        width: 2em;
      }

      .barra-1 {
        background-color: #6796cf;
      }
      
      .barra-2 {
        background-color: #c8bd63;
      }
      
      .barra-3 {
        background-color: #2d9484;
      }
      
      .final {
        border-top-right-radius: 0.2em;
        border-bottom-right-radius: 0.2em;
        margin-right: 1em;
      }
      
      .inicio {
        border-top-left-radius: 0.2em;
        border-bottom-left-radius: 0.2em;
        margin-left: 1em;
      }
    }
  }
`;

export const ThisGanntItem = styled.div`
  .item {
    display: flex;
    flex-direction: row;
    background: ${Colors.Color26};
    height: 3em;
    align-items: center;

    .col {
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 2em;
      align-items: center;
      justify-content: center;

      .card-dia{
        background: #2a2a2a;
        height: 1.6em;
        width: 2em;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;

        .dia {
          font-size: 0.65em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }

      .barra {
        background-color: #242424;
        height: 1em;
        width: 2em;
      }

      .barra-1 {
        background-color: #34639C;
      }
      
      .barra-2 {
        background-color: #79A8E1;
      }
      
      .barra-3 {
        background-color: #76C16A;
      }
      
      .final {
        border-top-right-radius: 0.2em;
        border-bottom-right-radius: 0.2em;
        margin-right: 1em;
      }
      
      .inicio {
        border-top-left-radius: 0.2em;
        border-bottom-left-radius: 0.2em;
        margin-left: 1em;
      }
    }
  }

  .light {
    background: ${Colors.Color8} !important;
  }

  .subItem {
    background: #282828 !important;
  }

  .subSubItem {
    background: #2f2f2f !important;
  }

`;

export const ScrollGantt = styled.div`
  width: calc(100%) !important;
  overflow-x: scroll;

  .content-right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: max-content;
  }
`;

export const ItemGanttHeader = styled.div`
  background: #242424;
  display: flex;
  flex-direction: row;
  height: 2em;
  width: ${(props) => props?.width}em;
  align-items: center;
  justify-content: center;
  position: relative;

  .semana {
    font-size: 0.7em;
    font-weight: bold;
    color: ${Colors.Color4};
  }

  ::before {
    position: absolute;
    content: "";
    height: 100%;
    width: 0.125em;
    top: 0em;
    right: 0em;
    background: ${Colors.Color4};
  }
`;
